var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getTyping && _vm.getCurrentlyChattingWith.id === _vm.getTypingUser.user_id)?_c('span',{staticClass:"mb-3 mx-3 typing"},[_vm._v(_vm._s(_vm.getTypingUser.name)+" "+_vm._s(_vm.$t("isTyping"))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }